import ProductCard from "@/app/(misc)/produk/components/ProductCard";

const Products: React.FC = () => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-5">
            <ProductCard data-aos="zoom-in">
                <ProductCard.Icon url="/images/product/icon-monitoring.png" />
                <ProductCard.Content>
                    <ProductCard.Title>Media Monitoring</ProductCard.Title>
                    <ProductCard.Subtitle>
                        Pantau media real-time dengan Komprehensif Media Monitoring.
                        Dapatkan analisis mendalam yang didukung oleh AI. Pastikan
                        bisnis Anda selalu selangkah lebih maju.
                    </ProductCard.Subtitle>
                </ProductCard.Content>
            </ProductCard>

            <ProductCard data-aos="zoom-in">
                <ProductCard.Icon url="/images/product/icon-visualize.png" />
                <ProductCard.Content>
                    <ProductCard.Title>Visualisasi Big Data</ProductCard.Title>
                    <ProductCard.Subtitle>
                        Visualisasi Data mencakup representasi grafis data dan
                        informasi untuk memudahkan pemahaman. Metode ini mencakup
                        penggunaan grafikdan tools visualisasi lainnya untuk
                        menyajikan wawasan kompleks secara intuitif.
                    </ProductCard.Subtitle>
                </ProductCard.Content>
            </ProductCard>

            <ProductCard data-aos="zoom-in">
                <ProductCard.Icon url="/images/product/icon-training.png" />
                <ProductCard.Content>
                    <ProductCard.Title>Pelatihan Big Data</ProductCard.Title>
                    <ProductCard.Subtitle>
                        Layanan pelatihan data fokus pada mengembangkan keahlian dan
                        keterampilan dalam pengelolaan dan analisis data. Pelatihan
                        ini mencakup pengoptimalan penggunaan alat dan teknologi untuk
                        memahami konsep-konsep kunci dalam pengolahan data.
                    </ProductCard.Subtitle>
                </ProductCard.Content>
            </ProductCard>

            <ProductCard data-aos="zoom-in">
                <ProductCard.Icon url="/images/product/icon-analize.png" />
                <ProductCard.Content>
                    <ProductCard.Title>Analisis Big Data</ProductCard.Title>
                    <ProductCard.Subtitle>
                        Analisis Big Data melibatkan pengolahan dan interpretasi data
                        dalam jumlah besar dan kompleks. Layanan ini fokus pada
                        pengidentifikasian pola, tren, dan wawasan yang dapat membantu
                        organisasi membuat keputusan yang lebih baik. Analisis Big
                        Data dapat mencakup teknik-teknik seperti machine learning,
                        analisis statistik, dan pemrosesan bahasa alami.
                    </ProductCard.Subtitle>
                </ProductCard.Content>
            </ProductCard>

            <ProductCard data-aos="zoom-in">
                <ProductCard.Icon url="/images/product/icon-collect.png" />
                <ProductCard.Content>
                    <ProductCard.Title>Pengumpulan Data</ProductCard.Title>
                    <ProductCard.Subtitle>
                        Pengumpulan Data melibatkan pengekstrakan informasi open
                        source dan pola dari dataset yang besar. Pengumpulan Data
                        mencakup penggunaan berbagai metode dan teknik untuk
                        mengidentifikasi hubungan yang belum diketahui, pola, atau
                        tren yang dapat memberikan wawasan berharga untuk pengambilan
                        keputusan.
                    </ProductCard.Subtitle>
                </ProductCard.Content>
            </ProductCard>

            <ProductCard data-aos="zoom-in">
                <ProductCard.Icon url="/images/product/icon-survey.png" />
                <ProductCard.Content>
                    <ProductCard.Title>Survey Komprehensif</ProductCard.Title>
                    <ProductCard.Subtitle>
                        Survey komprehensif dilakukan melalui platform yang dirancang
                        khusus untuk memberikan pengalaman kelas atas pada setiap
                        aspeknya.
                    </ProductCard.Subtitle>
                </ProductCard.Content>
            </ProductCard>

            <button className="flex h-full bg-slate-100 hover:bg-slate-200 rounded" data-aos="zoom-in">
                <ProductCard>
                    <ProductCard.Icon url="/images/product/icon-chat.png" />
                    <ProductCard.Content>
                        <ProductCard.Title>
                            Hubungi kami untuk info lebih lanjut
                        </ProductCard.Title>
                        <ProductCard.Subtitle>
                            Klik disini untuk melakukan diskusi dengan kami
                        </ProductCard.Subtitle>
                    </ProductCard.Content>
                </ProductCard>
            </button>
        </div>
    )
}

Products.displayName = "Products";
export default Products;